<template>
  <div style="width: 98%;margin: 0 auto;">
    <el-tabs v-model="activeName">
      <el-tab-pane label="会议室管理" name="first">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="会议室名称">
            <el-input v-model="formInline.name" clearable size="small" style="width:300px" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="会议室地点">
            <el-select v-model="formInline.address_id" style="width:400px" size="small" clearable placeholder="请选择">
              <el-option v-for="(ads,index) in addressList" :key="index" :label="ads.address" :value="ads.id">
                {{ ads.city }} - {{ ads.address }}</el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button size="mini" icon="el-icon-search" type="primary" @click="searchFormSubmit">查询</el-button>
          </el-form-item>
        </el-form>

        <!-- 会议列表 -->
        <el-card v-for="(item,index) in meetingList" :key="index" class="box-card">

          <el-row>
            <el-col :span="1" style="min-width: 70px;">
              <el-image :src="item.avatar" :preview-src-list="item.pictures" style="width: 50px; height: 50px"/>
            </el-col>
            <el-col :span="12">
              <div> <span class="title">{{ item.name }}</span>&nbsp;&nbsp;&nbsp;&nbsp;
                <span>可容纳人数：{{ item.capacity }}人</span> &nbsp;&nbsp;&nbsp;&nbsp;
              <span>管理员：{{ item.room_admin_name }}({{ item.telephone }})</span> </div>
              <p>会议室地点：{{ item.room_address.address }} - {{ item.area }}</p>

              <p>
                <el-tag v-for="(item2,index2) in item.equipments" :key="index2" type="info" size="small" effect="plain">
                  {{ item2.equipment_name }}</el-tag>
              </p>
            </el-col>
            <el-col :span="8" class="btn-tags">

              <el-tag type="success" size="medium" effect="dark" @click="drawer = true;editBtn(index);picClick=1">编辑
              </el-tag>
              <el-tag
                :type="item.room_status==0?'primary':'info'"
                size="medium"
                effect="dark"
                style="margin-right: 10px;"
                @click="disableBtn(item.id,item.room_status)">
                {{ item.room_status==0?'启用':'禁用' }}</el-tag>
                <!-- <el-tag type="warning" size="medium" @click="print('one', item)">打印二维码</el-tag> -->
            </el-col>

          </el-row>
        </el-card>
        <div style="margin-top: 10px;text-align: center;">
          <el-pagination
            :current-page="page"
            :page-sizes="[4, 10, 20, 50]"
            :page-size="page_size"
            :total="total"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"/>
        </div>

      </el-tab-pane>
      <el-tab-pane label="添加会议室" name="second">
        <el-card class="box-card" style="width: 80%;margin: 0 auto;">
          <div style="text-align:center;">
            <h2>添加会议室</h2>
            <hr>
          </div>

          <el-form
            ref="ruleForm"
            :model="ruleForm"
            :rules="rules"
            label-position="right"
            label-width="120px"
            class="demo-ruleForm">

            <el-row>
              <el-col :span="23">
                <el-form-item label="会议室图片">

                  <div class="icon-head" @click="addPlaseSelect">

                    <span>请选择 ></span>
                    <img v-if="ruleForm.picture !== false && ruleForm.picture.length > 0" :src="ruleForm.picture[0]" class="mintou-img" alt="">
                  </div>
                </el-form-item>
                <el-form-item label="会议室名称" prop="name">
                  <el-input v-model="ruleForm.name" clearable />
                </el-form-item>
                <el-form-item label="可容纳人数" prop="capacity">
                  <el-input v-model.number="ruleForm.capacity" clearable />
                </el-form-item>

                <el-form-item label="会议室设备" prop="equipment_ids">
                  <div class="tag-group">
                    <el-button size="small" @click="dialogTableVisible=true">请选择</el-button>
                    <el-tag
                      v-for="(eq,index) in multipleSelection"
                      :disable-transitions="false"
                      :key="index"
                      closable
                      effect="plain"
                      type="success"
                      @close="handleClose(index,eq.id)">
                      {{ eq.equipment_name }}</el-tag>
                  </div>
                </el-form-item>
                <el-form-item label="会议室状态" prop="room_status">
                  <el-radio-group v-model="ruleForm.room_status">
                    <el-radio label="1">可用</el-radio>
                    <el-radio label="0">不可用</el-radio>
                    <!-- 0 不可用 1 可用 -->

                  </el-radio-group>
                </el-form-item>

                <el-form-item label="会议室地址" prop="address_id">

                  <el-select v-model="ruleForm.address_id" clearable placeholder="请选择">
                    <el-option v-for="(ad,index) in addressList" :key="index" :label="ad.address" :value="ad.id">
                      {{ ad.city }},{{ ad.address }}</el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="所在区域" prop="area">
                  <el-input v-model="ruleForm.area" clearable placeholder="例：A区B区" />
                </el-form-item>
                <el-form-item label="管理员" prop="room_admin">
                  <el-select
                    v-model="ruleForm.room_admin"
                    :remote-method="getUserInfoByName"
                    :loading="selectLoading"
                    clearable
                    placeholder="请输入"
                    filterable
                    remote
                    reserve-keyword
                    @visible-change="clearSelectList">
                    <el-option
                      v-for="(user, indexUser) in personInChargeList"
                      :label="user.name+'('+user.username+')'"
                      :value="user.userId+'/'+user.username+'/'+user.name"
                      :key="indexUser" />
                  </el-select>
                </el-form-item>
                <el-form-item label="管理员电话" prop="telephone">
                  <el-input v-model.number="ruleForm.telephone" clearable />
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                  <el-input
                    v-model="ruleForm.remark"
                    :autosize="{ minRows: 2}"
                    clearable
                    type="textarea"
                    placeholder="请输入"
                    maxlength="1000"
                    show-word-limit />
                </el-form-item>
              </el-col>
            </el-row>
            <div style="text-align: center;">
              <el-button type="primary" style="width:250px;" @click="submitForm('ruleForm')">立即创建</el-button>
              <el-button style="width:250px;" @click="resetForm('ruleForm')">重置</el-button>
            </div>
          </el-form>
        </el-card>

      </el-tab-pane>

    </el-tabs>

    <!-- 编辑会议室 -->
    <el-drawer :visible.sync="drawer" title="编辑会议室" direction="rtl" size="700px">
      <el-form
        ref="editForm"
        :model="editForm"
        :rules="rules"
        label-position="right"
        label-width="120px"
        class="demo-ruleForm">

        <el-row>
          <el-col :span="23">
            <el-form-item label="会议室图片">

              <div class="icon-head" @click="dialogVisible = true;">

                <span>请选择 ></span>
                <img v-show="editForm.avatar !== false" :src="editForm.avatar" class="mintou-img" alt="">
              </div>
            </el-form-item>
            <el-form-item label="会议室名称" prop="name">
              <el-input v-model="editForm.name" clearable />
            </el-form-item>
            <el-form-item label="可容纳人数" prop="capacity">
              <el-input v-model.number="editForm.capacity" clearable />
            </el-form-item>

            <el-form-item label="会议室设备" prop="equipment_ids">
              <div class="tag-group">
                <el-button size="small" @click="pleaseSelect">请选择</el-button>
                <!-- <el-tag closable :disable-transitions="false" @close="handleClose2(index,eq.id)"
                  v-for="(eq,index) in equipmentsList2" :key="eq.id" effect="plain" type="success">{{eq.equipment_name}}
                </el-tag> -->
              </div>

            </el-form-item>
            <el-form-item label="会议室状态" prop="room_status">
              <el-radio-group v-model="editForm.room_status">
                <el-radio :label="1">可用</el-radio>
                <el-radio :label="0">不可用</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="会议室地址" prop="address_id">
              <el-select v-model="editForm.address_id" size="small" clearable placeholder="请选择">
                <el-option v-for="(ad,index) in addressList" :key="index" :label="ad.address" :value="ad.id">
                  {{ ad.city }},{{ ad.address }}</el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="所在区域" prop="area">
              <el-input v-model="editForm.area" clearable placeholder="例：A区B区" />
            </el-form-item>
            <el-form-item label="管理员" prop="room_admin">
              <el-select
                v-model="editForm.room_admin"
                :remote-method="getUserInfoByName"
                :loading="selectLoading"
                clearable
                placeholder="请输入"
                filterable
                remote
                reserve-keyword
                @visible-change="clearSelectList">
                <el-option
                  v-for="(user, indexUser) in personInChargeList"
                  :label="user.name+'('+user.username+')'"
                  :value="user.userId+'/'+user.username+'/'+user.name"
                  :key="indexUser" />
              </el-select>

            </el-form-item>
            <el-form-item label="管理员电话" prop="telephone">
              <el-input v-model="editForm.telephone" clearable />
            </el-form-item>
            <el-form-item label="备注" prop="remark">
              <el-input
                v-model="editForm.remark"
                :autosize="{ minRows: 2}"
                clearable
                type="textarea"
                placeholder="请输入"
                maxlength="1000"
                show-word-limit />
            </el-form-item>

          </el-col>
        </el-row>
        <div style="text-align: center;">
          <el-button type="primary" style="width:250px;" @click="submitEdit('editForm')">保存修改</el-button>
          <el-button style="width:250px;" @click="drawer=false">取消</el-button>
        </div>
      </el-form>

    </el-drawer>
    <!-- 编辑会议室 -->
    <!-- 头像 -->
    <el-dialog :visible.sync="dialogVisible" title="会议室图片" width="800px">
      <div class="dialog-content">
        <div class="dialog-left">
          <img v-for="(ss,i) in pictureSelected" :key="i" :src="ss" @click="removeImg(i)" >
        </div>
        <div class="dialog-right">
          <el-upload
            :headers="{Authorization:token}"
            :data="{'upload_type':'image'}"
            :on-preview="handlePictureCardPreview"
            :on-success="uploadSuccess"
            :file-list="fileList"
            :on-remove="handleRemove"
            :action="actionUpload"
            list-type="picture-card"
            name="files"
            accept=".jpg,.jpeg,.png,.gif,.bmp,.pdf,.JPG,.JPEG,.PBG,.GIF,.BMP,.PDF">
            <i class="el-icon-plus"/>
          </el-upload>
          <br>
          <el-dialog :visible.sync="dialogVisibleImg" append-to-body>
            <img :src="dialogImageUrl" width="100%" alt="">
          </el-dialog>
          <!-- <img v-for="(url,index) in srcList" :src="url" @click="pushImg(index)"> -->
          <div>
            <!-- <el-image v-for="(pic,index) in srcList" :key="index" style="width: 100px; height: 100px;margin-right:5px"
              :src="pic" @click="pushImg(index)" :preview-src-list="srcList">
            </el-image> -->
            <!-- 点击下面的图片 才可以添加到左侧的图片列表 -->
            <p v-if="srcList && srcList.length > 0" class="tip_text">点击下方图片 添加到左侧作为会议室图片</p>
            <img
              v-for="(pic,index) in srcList"
              :key="index"
              :src="pic"
              style="width: 100px; height: 100px;margin-right:5px"
              alt=""
              @click="pushImg(index)" >
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">

        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="picEnter">确 定</el-button>

      </span>
    </el-dialog>

    <el-dialog :visible.sync="dialogTableVisible" title="选择会议设备">
      <el-table
        ref="multipleTable"
        :data="equipmentList"
        :header-cell-style="{background:'#41A1FF',color:'#fff'}"
        @selection-change="handleSelectionChange">

        <el-table-column type="selection" width="55"/>
        <el-table-column property="equipment_name" label="设备名"/>
        <el-table-column property="describe" label="设备备注"/>
        <el-table-column label="图片">
          <template slot-scope="scope">
            <el-image
              :src="scope.row.img_url?scope.row.img_url[0]:''"
              :preview-src-list="scope.row.img_url?scope.row.img_url:''"
              style="width: 50px; height: 50px"/>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog :visible.sync="dialogTableVisible2" title="选择会议设备">
      <el-table
        ref="multipleTable2"
        :data="equipmentList"
        :header-cell-style="{background:'#41A1FF',color:'#fff'}"
        @selection-change="handleSelectionChange2">

        <el-table-column type="selection" width="55"/>
        <el-table-column property="equipment_name" label="设备名"/>
        <el-table-column property="describe" label="设备备注"/>
        <el-table-column label="图片">
          <template slot-scope="scope">

            <el-image
              :src="scope.row.img_url?scope.row.img_url[0]:''"
              :preview-src-list="scope.row.img_url?scope.row.img_url:''"
              style="width: 50px; height: 50px"/>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
<printDialog
:visible="printVisible"
:printArr="printArr"
@close="closeVisible"
 />
  </div>
</template>

<script>
import { getUserInfoByName, getUserInfoById } from '@/api/login'
import { searchAddress } from '@/api/city'
import { addMeeting, deleteMeeting, searchMeeting, editMeeting, getQrcode } from '@/api/mettingManagement'
import { searchEquipment } from '@/api/equipment'
import { upload } from '@/api/common'
import printDialog from './component/printDialog'

export default {
  components: { printDialog },
  data() {
    return {
      actionUpload: `${process.env.VUE_APP_BASE_API}/common/upload`,
      activeName: 'first',
      drawer: false,
      meetingList: [],
      token: this.$store.getters.token,
      ruleForm: {
        name: '',
        address_id: '',
        equipment_ids: [],
        capacity: '',
        room_status: '1',
        room_admin: '',
        room_admin_id: '',
        room_admin_name: '',
        room_admin_workcode: '',
        telephone: '',
        remark: '',
        area: '',
        picture: []
      },
      editForm: {
        id: '',
        name: '',
        address_id: '',
        equipment_ids: [],
        capacity: '',
        room_status: '',
        room_admin: '',
        room_admin_id: '',
        room_admin_name: '',
        room_admin_workcode: '',
        telephone: '',
        remark: '',
        area: '',
        avatar: '',
        picture: [null]
      },
      formInline: {
        name: '',
        address_id: '',
        page_size: 4
      },
      // 添加会议dialogImageUrl
      dialogTableVisible: false,
      dialogTableVisible2: false,
      dialogVisible: false,
      dialogImageUrl: '',
      dialogVisibleImg: false,
      picClick: '', // 判断点击的是添加表单还是编辑表单
      pictureSelected: [],
      srcList: [],
      total: 0,
      page: 1,
      page_size: 4,
      fileList: [],
      rules: {
        name: [
          { required: true, message: '请输入会议室名称', trigger: 'blur' },
          { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
        ],
        address_id: [
          { required: true, message: '请选择地址', trigger: 'blur' }
        ],
        equipment_ids: [
          { type: 'array', required: true, message: '请选择设备', trigger: 'change' }
        ],
        capacity: [
          { required: true, message: '请输入容纳人数', trigger: 'blur' }
        ],
        room_admin: [
          { required: true, message: '请选择管理员', trigger: 'change' }
        ],
        telephone: [
          { required: true, message: '请输入联系方式', trigger: 'blur' }
        ],
        area: [
          { required: true, message: '请输入区域', trigger: 'blur' }
        ],
        remark: [
          { required: false, message: '请填写备注', trigger: 'blur' }
        ]
      },
      selectLoading: false,
      personInChargeList: [], // 搜索用户相关
      addressList: [],
      equipmentList: [], // 获取的
      multipleSelection: [], // 选中显示的
      equipmentsList2: [], // 选中显示的
      printVisible: false,
      printArr: []
    }
  },
  created() {
    this.searchSubmit(this.formInline)
    this.getAddress()
    this.getEquipment()
  },

  methods: {
    getAddress() {
      searchAddress().then(response6 => {
        const data = response6.data.address
        if (data.length) {
          this.addressList = data
        } else {
          this.addressList = []
        }
      }).catch(() => { })
    },
    getEquipment() {
      searchEquipment().then(response3 => {
        if (response3.code === 'success') {
          const data = response3.data.equipment.equipments
          this.equipmentList = data
        } else {
          this.equipmentList = []
          this.errMsg()
        }
      }).catch()
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const arr = this.ruleForm.room_admin.split('/')
          this.ruleForm.room_admin_id = arr[0]
          this.ruleForm.room_admin_workcode = arr[1]
          this.ruleForm.room_admin_name = arr[2]

          addMeeting(this.ruleForm).then(response1 => {
            if (response1.code === 'success') {
              this.successMsg()
              this.resetForm(formName)
              this.searchSubmit(this.formInline)
              this.activeName = 'first'
            } else {
              this.errMsg()
            }
          }).catch()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    submitEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const arr = this.editForm.room_admin.split('/')
          this.editForm.room_admin_id = arr[0]
          this.editForm.room_admin_workcode = arr[1]
          this.editForm.room_admin_name = arr[2]
          editMeeting(this.editForm).then(response4 => {
            if (response4.code === 'success') {
              this.successMsg()
              this.searchSubmit(this.formInline)
              this.drawer = false
            } else {
              this.errMsg()
            }
          }).catch()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    successMsg() {
      this.$message({
        message: '操作成功',
        type: 'success'
      })
    },
    errMsg() {
      this.$message({
        message: '操作失败',
        type: 'error'
      })
    },
    // 多选头像
    pushImg(i) {
      var ele = this.srcList[i]
      const pic = this.pictureSelected
      for (var j = 0; j <= pic.length; j++) {
        if (pic.indexOf(ele) === -1) {
          pic.push(ele)
        }
      }
      this.pictureSelected = pic
    },
    removeImg(i) {
      this.pictureSelected.splice(i, 1)
    },
    picEnter() {
      this.dialogVisible = false
      if (this.picClick === 0) {
        this.ruleForm.picture = JSON.parse(JSON.stringify(this.pictureSelected))
        this.ruleForm.avatar = JSON.parse(JSON.stringify(this.pictureSelected[0]))
      } else {
        this.editForm.picture = JSON.parse(JSON.stringify(this.pictureSelected))
        this.editForm.avatar = JSON.parse(JSON.stringify(this.pictureSelected[0]))
      }
    },
    // 编辑会议请选择，清空选项再赋值
    pleaseSelect() {
      this.dialogTableVisible2 = true
      this.toggleSelection2()
    },
    toggleSelection2() {
      var that = this
      that.$nextTick(() => {
        console.log(that.$refs.multipleTable2)
        if (that.$refs.multipleTable2) {
          that.$refs.multipleTable2.clearSelection()
        }
        that.equipmentList.forEach(row => {
          for (const j in that.equipmentsList2) {
            if (row.id === that.equipmentsList2[j].id) {
              // console.log("相同");
              that.$refs.multipleTable2.toggleRowSelection(
                row,
                true
              )
            }
          }
        })
      })
    },
    // 删除tag
    handleClose2(index, id) {
      const arr = this.equipmentsList2.splice(index, 1)
      this.equipmentsList2 = arr
      // this.toggleSelection2(arr);
    },
    handleSelectionChange2(val) {
      const arr = []
      for (const i of val) {
        arr.push(i.id)
      }
      this.editForm.equipment_ids = arr
    },
    // 搜索用户
    getUserInfoByName(query) {
      if (query !== '') {
        this.selectLoading = true
        const params = {
          name: query,
          pageNum: 1,
          page_size: 10
        }
        getUserInfoByName(params).then(res => {
          this.personInChargeList = res.data.list
          this.selectLoading = false
        })
      }
    },
    // 选中之后清空用户list
    clearSelectList(val) {
      if (val === false) {
        this.personInChargeList = []
      }
    },
    // 多选打勾
    handleSelectionChange(val) {
      this.multipleSelection = val
      this.ruleForm.equipment_ids = []

      const ids = []
      val.map(v => {
        ids.push(v.id)
      })
      this.ruleForm.equipment_ids = ids
    },
    // 编辑多选打勾

    // 删除tag
    handleClose(index, id) {
      const arr = this.multipleSelection.splice(index, 1)
      this.multipleSelection = arr
      this.toggleSelection(arr)
    },
    // 切换,指定选中
    toggleSelection(rows) {
      console.log(rows, 'rows')
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row)
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },

    // 会议室图片
    uploadImg(file) {
      upload(file).then(res => { })
    },
    handleRemove(file, fileList) {
      console.log(file, fileList)
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.response.data.urls
      this.dialogVisibleImg = true
    },
    uploadSuccess(response) {
      if (response.data && response.data.urls) {
        this.srcList = this.srcList.concat(response.data.urls)
      }
    },
    // 禁用会议室
    disableBtn(id, room_status) {
      if (room_status) { // 1，可用的时候，禁用
        room_status = 0
      } else {
        room_status = 1
      }
      this.$confirm(room_status === 0 ? '禁用这个会议室' : '启用这个会议室', '是否继续?', '提示', {
        confirmButtonText: '禁用',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const data = {
          id: id,
          room_status: room_status
        }
        editMeeting(data).then(response6 => {
          if (response6.code === 'success') {
            this.searchSubmit(this.formInline)
            this.successMsg()
          } else {
            this.errMsg()
          }
        }).catch()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        })
      })
    },
    // 删除会议室
    deleteBtn(id, i) {
      this.$confirm('此操作将删除这个会议, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteMeeting(id).then(response2 => {
          if (response2.code === 'success') {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            this.meetingList.splice(i, 1)
          }
        }).catch(err => { console.log(err) })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // 查询会议室
    searchFormSubmit() {
      const data = {
        name: this.formInline.name,
        address_id: this.formInline.address_id,
        page: 1,
        page_size: this.page_size
      }
      this.searchSubmit(data)
    },
    searchSubmit(form) {
      searchMeeting(form).then(response3 => {
        const list = response3.data
        if (list.rooms.length > 0) {
          this.meetingList = list.rooms
          this.total = list.pagination.total
          this.page = list.pagination.current_page
        } else {
          this.meetingList = []
          this.total = 0
        }
      }).catch(() => { })
    },
    // 添加会议室的请选择
    addPlaseSelect() {
      this.dialogVisible = true
      // if (this.picClick === 1) {
      this.picClick = 0
      this.fileList = []
      this.pictureSelected = []
      this.srcList = []
      // } else {
      //   this.picClick = 0
      // }
    },

    // 编辑会议室
    editBtn(i) {
      this.fileList = []
      this.pictureSelected = []
      this.pictureSelected = this.meetingList[i].pictures
      this.editForm = {}
      const form = {}
      form.id = this.meetingList[i].id
      form.picture = this.meetingList[i].pictures
      form.name = this.meetingList[i].name
      form.capacity = this.meetingList[i].capacity
      form.room_status = this.meetingList[i].room_status
      form.telephone = this.meetingList[i].telephone
      form.room_admin = this.meetingList[i].room_admin_id + '/' + this.meetingList[i].room_admin_workcode + '/' + this.meetingList[i].room_admin_name
      form.room_admin_id = Number(this.meetingList[i].room_admin_id)
      form.room_admin_name = this.meetingList[i].room_admin_name
      form.room_admin_workcode = this.meetingList[i].room_admin_workcode
      form.address_id = this.meetingList[i].address_id
      form.remark = this.meetingList[i].remark
      form.area = this.meetingList[i].area
      form.avatar = this.meetingList[i].avatar

      this.pictureSelected = this.meetingList[i].pictures
      this.pictureSelected = JSON.parse(JSON.stringify(this.meetingList[i].pictures))
      this.srcList = JSON.parse(JSON.stringify(this.meetingList[i].pictures))// 选择头像左图片减一有影响
      const arr = []
      const arrYuan = this.meetingList[i].equipments

      for (var v of arrYuan) {
        arr.push(v.id)
        v.add_time = ''
        v.update_time = ''
        v.user_id = ''
      }
      this.meetingList[i].equipments = arrYuan
      getUserInfoById(form.room_admin_id)
        .then(res => {
          this.personInChargeList.push(res.data)
        })
        .catch(() => { })
      form.equipment_ids = arr
      this.editForm = form
      this.equipmentsList2 = this.meetingList[i].equipments
    },
    // 点击添加重置
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.multipleSelection = []
      this.ruleForm.picture = []
    },
    handleSizeChange(val) {
      this.page_size = val
      this.formInline.page_size = val
      const data = this.formInline
      data.page = 1// 从第一页开始查
      this.searchSubmit(data)
    },
    handleCurrentChange(val) {
      this.page = val
      const data = this.formInline
      data.page = val
      this.searchSubmit(data)
    },
    print(type, item) {
      this.printArr = []

      const url = `http://meeting.suntekcorps.com:8060/#/appointment?id=` + item.id// 正式的访问地址

      getQrcode({ content: url })
        .then(res => {
          const json = {
            img: 'data:image/jpeg;base64,' + res.data,
            name: item.name
          }
          this.printArr.push(json)
        })
        .catch(err => {
          return err
        })
      this.printVisible = true
    },
    closeVisible() {
      this.printVisible = false
    }

  }
}

</script>

<style scoped>
  .box-card {
    font-size: 14px;
    color: rgb(94, 90, 90);
  }

  .title {
    font-size: 20px;
    color: #000;
  }

  .addMetting {
    border-radius: 10px;
    padding: 20px 0 20px 0;
    /* border:1px solid #ccc; */
    height: 800px;
    width: 100vh;
    margin: 0 auto;
    box-shadow: 0 8px 16px 0 rgba(7, 17, 27, .1);
    background: linear-gradient(180deg, rgba(187, 180, 180, 0), rgba(175, 174, 174, 0.336));
  }

  .el-select {
    width: 100%;
  }

  .el-form-item {
    /* margin-bottom: 3px; */
  }

  .el-form--label-top .el-form-item__label {
    padding: 0;
  }

  .icon-head {
    color: #ccc;
    /* border: 1px solid #f8f8f8; */
    height: 30px;
    width: 100%;
    cursor: pointer;
  }

  .icon-head span {
    float: right;
    color: #ccc;
  }

  .dialog-left {
    float: left;
    width: 70px;
    margin-right: 10px;
    border-right: 1px solid #ccc;
    height: 300px;
  }

  .dialog-left img,
  .dialog-right img {
    width: 50px;
    height: 50px;
    margin: 5px;
    cursor: pointer;
  }

  .dialog-right {
    float: left;
    width: 600px;
  }

  .dialog-content {
    width: 100%;
    height: 400px;
    overflow: auto;
  }

  .mintou-img {
    float: right;
    vertical-align: middle;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 10px;
  }

  .btn-tags .el-tag--dark {
    cursor: pointer;
  }

  .el-card {
    margin-bottom: 15px;
  }

  .el-tag+.el-tag {
    margin-left: 10px;
  }

  .tip_text{
    height: 24px;
    padding: 0 8px;
    line-height: 22px;
    color: #909399;
  }
</style>
